/* ============================================================
   YOLÈTE — Catalogue MAROQUINERIE (sacs + anses amovibles)
   ------------------------------------------------------------
   Chargé APRÈS data.js (site statique) ou après data-shopify.js
   (thème Shopify), AVANT common.js.

   Deux sources, une seule sortie :
     · Thème Shopify  -> window.SHOP.sacs, émis par le snippet
       yolete-data.liquid depuis la collection « maroquinerie ».
       Prix, stock et visuels suivent alors la boutique en direct.
     · Site statique  -> la liste FALLBACK ci-dessous, relevée dans
       l'admin Shopify le 16 septembre 2026 à 16 h. data.js est
       régénéré depuis les endpoints publics, qui ignorent les
       brouillons : tant que la collection n'est pas publiée, elle
       ne peut pas venir de là.

   Types ajoutés au catalogue : 'sac' et 'anse'.
   ============================================================ */
(function () {
  if (typeof PRODUCTS === 'undefined') return;

  var CDN = 'https://cdn.shopify.com/s/files/1/0790/8714/1213/files/';

  /* Ordre d'affichage : la pièce de caractère d'abord, du plus grand
     au plus petit, les anses amovibles en fin de grille. */
  var ORDER = ['ariane', 'angele', 'alina', 'astrid', 'bella40', 'bella25'];

  /* Photos portées fournies par la maison le 16 septembre 2026, ajoutées
     EN TÊTE de galerie : une pièce portée vend mieux qu'une page de book
     détourée. Appliquées aux deux sources, pour que la publication des
     produits dans Shopify ne les fasse pas disparaître. */
  var PHOTOS_EN_PLUS = {
    astrid:  ['https://cdn.shopify.com/s/files/1/0790/8714/1213/files/maroquinerie__astrid-havane-portee.jpg?v=1789569657'],
    bella40: ['https://cdn.shopify.com/s/files/1/0790/8714/1213/files/maroquinerie__bella-anse-boucle.jpg?v=1789569664'],
    bella25: ['https://cdn.shopify.com/s/files/1/0790/8714/1213/files/maroquinerie__bella-anse-boucle.jpg?v=1789569664']
  };

  /* Détourés haute définition, ré-extraits du PDF « Books 2026/MAROQUINERIE-3 ».
     Les visuels fond blanc chargés dans Shopify sont des recadrages du même book
     mais enregistrés entre 212 et 468 pixels de large, alors qu'une carte en
     affiche 390 et jusqu'à 780 sur un écran dense : ils étaient donc étirés.
     Les images du PDF font 650 à 1450 pixels, une page = un produit, ce qui rend
     l'attribution certaine. */
  var PACKSHOTS = {
    ariane:  ['https://cdn.shopify.com/s/files/1/0790/8714/1213/files/maroquinerie__book__ariane.png?v=1789570856'],
    angele:  ['https://cdn.shopify.com/s/files/1/0790/8714/1213/files/maroquinerie__book__angele.png?v=1789570848', 'https://cdn.shopify.com/s/files/1/0790/8714/1213/files/maroquinerie__book__angele-anse.png?v=1789570841'],
    alina:   ['https://cdn.shopify.com/s/files/1/0790/8714/1213/files/maroquinerie__book__alina.png?v=1789570834',  'https://cdn.shopify.com/s/files/1/0790/8714/1213/files/maroquinerie__book__alina-anse.png?v=1789570827'],
    astrid:  ['https://cdn.shopify.com/s/files/1/0790/8714/1213/files/maroquinerie__book__astrid.png?v=1789570869', 'https://cdn.shopify.com/s/files/1/0790/8714/1213/files/maroquinerie__book__astrid-anse.png?v=1789570862'],
    bella40: ['https://cdn.shopify.com/s/files/1/0790/8714/1213/files/maroquinerie__book__bella40.png?v=1789570883'],
    bella25: ['https://cdn.shopify.com/s/files/1/0790/8714/1213/files/maroquinerie__book__bella25.png?v=1789570876']
  };

  /* Les recadrages basse définition envoyés dans Shopify portent tous ce motif.
     Dès qu'on a le détouré haute définition, on retire l'ancien de la galerie. */
  var BASSE_DEF = /Book[_]?Maro[_]?Nathan/i;

  /* Repères éditoriaux que Shopify ne porte pas : accroche de carte et
     dimensions lisibles (la fiche Shopify les écrit « 26x 18X10cm »). */
  /* Fiches techniques relevées dans le book maison « MAROQUINERIE-3 »
     (Automne Hiver 26/27, livraison annoncée fin octobre). Shopify ne porte ni
     la référence atelier, ni la boucle compatible, ni les dimensions lisibles :
     la fiche Shopify écrit « 26x 18X10cm ». */
  var META = {
       ariane: { eyebrow: 'Cuir poilu',    dims: '40 × 35 × 15 cm', cuir: 'Cuir poilu Savane fauve et cuir Vintage noir ',
              ref: '00941', ferm: 'Fermeture aimantée', anse: 'Anse fixe',
              detail: 'Bicolore fauve et noir, petite poche intérieure, rivets. Livré avec son pochon.',
              doublure: 'Sac non doublé', rivets: 'Rivets latéraux',
              compat: 'Reçoit nos anses Bella 25 et Bella 40' },
    angele: { eyebrow: 'Porté épaule',  dims: '26 × 18 × 10 cm', cuir: 'Cuir Vintage',
              ref: '0996', ferm: 'Fermeture aimantée, rivet décoratif Lucane', anse: 'Anse poignée amovible',
              detail: 'Sac en cuir VINTAGE black, havane ou brown, tannage végétal. Existe en 2 versions : anse courte et anse longue. Livré avec son pochon.',
              doublure: 'Sac non doublé', rivets: 'Rivets latéraux',
              compat: 'Reçoit notre anse Bella 40', prixBook: { court: 169.0, long: 249.5 } },
    alina:  { eyebrow: 'Grand format',  dims: '24 × 8 × 8 cm', cuir: 'Cuir Vintage',
              ref: '0056', ferm: 'Fermeture aimantée, rivet décoratif Lucane', anse: 'Anse poignée amovible',
              detail: 'Sac en cuir VINTAGE black, havane ou brown, tannage végétal.&nbsp;Existe en 2 versions : anse courte et anse longue. Livré avec son pochon.',
              doublure: 'Sac non doublé', rivets: 'Rivets latéraux',
              compat: 'Reçoit nos anses Bella 25 et Bella 40', prixBook: { court: 159.0, long: 239.5 } },
    astrid: { eyebrow: 'Baguette',      dims: '25 × 14 × 8 cm',  cuir: 'Cuir Vintage',
              ref: '0995', ferm: 'Fermeture aimantée, rivet décoratif Lucane', anse: 'Petite anse poignée amovible',
              detail: 'Sac en cuir VINTAGE black, havane ou brown, tannage végétal. Livré avec son pochon.',
              doublure: 'Sac non doublé', rivets: 'Rivets latéraux',
              compat: 'Reçoit nos anses Bella 25 et Bella 40', prixBook: { court: 139.5 } },
    bella40:{ eyebrow: 'Anse amovible', dims: '115 cm × 40 mm',  cuir: 'Cuir Vintage',
              ref: '0993', ferm: 'Boucle N371 interchangeable', anse: 'Longueur réglable 101 à 115 cm',
              detail: 'Se clipse sur les anneaux de tous nos sacs, et reçoit nos boucles interchangeables.',
              compat: 'S\'adapte sur tous nos sacs', prixBook: { court: 99.9 } },
    bella25:{ eyebrow: 'Anse amovible', dims: '115 cm × 25 mm',  cuir: 'Cuir Vintage',
              ref: '0053', ferm: 'Boucle N321 interchangeable', anse: 'Longueur réglable 101 à 115 cm',
              detail: 'Se clipse sur les anneaux de tous nos sacs, et reçoit nos boucles interchangeables.',
              compat: 'S\'adapte sur tous nos sacs', prixBook: { court: 79.9 } }
  };

  var ANSES = { bella25: 1, bella40: 1 };

  /* Shopify nomme deux fiches « ALINA et ALINA/ANSE » et « ANGELE et
     ANGELE/ANSE » parce qu'elles portent une seconde option, la longueur
     d'anse. Ce libellé n'a rien à faire sur une carte : on garde le nom
     de la pièce et l'option se lit dans la fiche. */
  function nomCourt(titre) {
    return String(titre || '').split(/\s+et\s+/i)[0].trim() || titre;
  }

  /* --- Repli : relevé de l'admin Shopify, collection « maroquinerie ». --- */
  var FALLBACK = [
    { id: 'ariane', name: 'ARIANE', price: 369.0,
      images: ['ARIANE.jpg?v=1789488375', 'BookMaroNathan-3.png?v=1789488163'],
      colors: [],
      descr: 'Sac en cuir poilu Savane fauve. Petite poche intérieure, fermeture aimantée, rivets. Anse fixe, et la possibilité d\'adapter nos anses amovibles Bella 25 et Bella 40, à boucle amovible et longueur réglable.' },
    { id: 'angele', name: 'ANGELE', price: 169.0,
      images: ['ANGELE.jpg?v=1789490711', 'BookMaroNathan-6.png?v=1789490477',
               'Book_Maro_Nathan-7.png?v=1789490540', 'Book_Maro_Nathan-13.png?v=1789563690'],
      colors: ['Noir', 'Brown', 'Havane'],
      descr: 'Sac en cuir Vintage. Petite anse poignée amovible, fermeture aimantée, rivets latéraux et rivet décoratif Lucane sur la fermeture. Livré avec son pochon. Anse courte amovible ou anse longue amovible, au choix.' },
    { id: 'alina', name: 'ALINA', price: 159.0,
      images: ['ALINA.jpg?v=1789563690', 'BookMaroNathan-11.png?v=1789491197',
               'BookMaroNathan-12.png?v=1789491196', 'Book_Maro_Nathan-15.png?v=1789563690'],
      colors: ['Noir', 'Brown', 'Havane'],
      descr: 'Sac en cuir Vintage. Petite anse poignée amovible, fermeture aimantée, rivets latéraux et rivet décoratif Lucane sur la fermeture. Livré avec son pochon. Anse courte amovible ou anse longue amovible, au choix.' },
    { id: 'astrid', name: 'ASTRID', price: 139.5,
      images: ['ASTRID.jpg?v=1789563690',
               'BookMaroNathan-3_396b9122-4d9f-4296-8937-54dab2e1cc5f.png?v=1789495416',
               'BookMaroNathan-4_79a497bd-2727-4cca-9df2-59a0096763b1.png?v=1789495416'],
      colors: ['Noir', 'Brown', 'Havane'],
      descr: 'Sac en cuir Vintage. Petite anse poignée amovible, fermeture aimantée, rivets latéraux et rivet décoratif Lucane sur la fermeture. Livré avec son pochon.' },
    { id: 'bella40', name: 'BELLA40', price: 99.9,
      images: ['BookMaroNathan-6_c4231866-2380-42e0-aad3-bfbd79f69ca8.png?v=1789495745'],
      colors: ['Noir', 'Brown', 'Havane'],
      descr: 'Anse amovible en cuir Vintage, largeur 40 mm, boucle interchangeable sur l\'anse et longueur réglable. Adaptable sur tous nos sacs.' },
    { id: 'bella25', name: 'BELLA25', price: 79.9,
      images: ['BookMaroNathan-5_6ad3fcfc-ad5a-4563-82bd-ea6879ef819a.png?v=1789495594'],
      colors: ['Noir', 'Brown', 'Havane'],
      descr: 'Anse amovible en cuir Vintage, largeur 25 mm, boucle interchangeable sur l\'anse et longueur réglable. Adaptable sur tous nos sacs.' }
  ];

  /* Teintes à plat des trois coloris maison, pour les pastilles : une photo
     réduite à 22 px ne montre rien du cuir. */
  var TEINTE = { 'Noir': '#1b1714', 'Black': '#1b1714', 'Brown': '#5d3a22', 'Havane': '#9a6b3f' };

  function echapper(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* Description de la fiche Shopify, telle que Charlotte l'écrit : un paragraphe,
     « DETAILS : », puis une liste à puces. Le texte avant la liste fait la
     Description de la fiche du site, la liste (et ce qui la suit) fait les Détails.
     On ne garde que le texte : les descriptions collées depuis un autre outil
     portent des <span class style> qui changeraient la police et la couleur. */
  function lireDescription(h) {
    var r = { intro: '', details: [], dims: '' };
    if (!h || typeof DOMParser === 'undefined') return r;
    var corps = new DOMParser().parseFromString(String(h), 'text/html').body;
    var avant = [], vuListe = false;
    var propre = function (t) { return String(t || '').replace(/\s+/g, ' ').trim(); };
    var ligne = function (t) {
      var dim = /^dimensions?\s*:?\s*(.+)$/i.exec(t);
      if (dim) {
        /* « 40x35x15cm » s'écrit « 40 × 35 × 15 cm », comme sur les autres pièces */
        var d = dim[1].replace(/(\d)\s*[x×X*]\s*(?=\d)/g, '$1 × ').replace(/(\d)\s*(cm|mm)\b/g, '$1 $2');
        if (!r.dims) r.dims = echapper(d);
        t = t.slice(0, t.length - dim[1].length) + d;
      }
      r.details.push(echapper(t.charAt(0).toUpperCase() + t.slice(1)));
    };
    Array.prototype.forEach.call(corps.childNodes, function (n) {
      if (n.nodeType === 1 && /^(UL|OL)$/.test(n.tagName)) {
        vuListe = true;
        n.querySelectorAll('li').forEach(function (li) { var t = propre(li.textContent); if (t) ligne(t); });
        return;
      }
      var t = propre(n.textContent);
      if (!t || /^d[ée]tails?\s*:?$/i.test(t)) return;
      if (vuListe) ligne(t); else avant.push(t);
    });
    r.intro = echapper(avant.join(' '));
    return r;
  }

  function decorate(o, deShopify) {
    /* Fiche lue dans Shopify, en ligne ou dans la copie des brouillons : TOUT
       vient de la fiche, rien du relevé du book, pour que Charlotte modifie tout
       dans l'admin (Nathan, 28 sept 2026). Le relevé du book (META, PACKSHOTS,
       PHOTOS_EN_PLUS) ne sert plus qu'au site statique. */
    var m = {}, k, book = deShopify ? {} : (META[o.id] || {}), shop = o.maro || {};
    for (k in book) m[k] = book[k];
    for (k in shop) if (shop[k]) m[k] = shop[k];
    var desc = lireDescription(o.descrHtml);
    o.descrIntro = desc.intro;
    o.detailsListe = desc.details;
    /* Une anse amovible se reconnaît à son accroche « Anse amovible » ou à
       l'étiquette « anse », pour qu'une nouvelle anse saisie par Charlotte se
       range avec les anses sans toucher au code. */
    o.type = (ANSES[o.id] || /^anse/i.test(m.eyebrow || '')
      || (o.tags || []).some(function (t) { return /^anses?$/i.test(t); })) ? 'anse' : 'sac';
    o.width = null;                 /* un sac n'a pas de largeur de boucle */
    o.style = null;
    o.audience = 'femme';
    o.collections = [];
    o.eyebrow = m.eyebrow || (o.type === 'anse' ? 'Anse amovible' : 'Maroquinerie');
    o.dims = desc.dims || m.dims || '';
    o.cuir = m.cuir || '';
    o.refAtelier = m.ref || '';
    o.fermeture = m.ferm || '';
       o.anse = m.anse || '';
    o.detail = m.detail || '';
    o.doublure = m.doublure || '';
    o.rivets = m.rivets || '';
    o.compat = m.compat || '';
    o.prixBook = m.prixBook || null;
    /* Précommande : phrase saisie dans la fiche Shopify (champ precommande).
       Vide, la pièce se vend normalement. */
    o.precommande = o.precommande || '';
    /* Facette « couleur dominante » de la boutique : on mappe les libellés
       Shopify sur les clés du site. */
    o.couleur = (o.colors || []).map(function (c) {
      var n = (c.name || c).toLowerCase();
      return n === 'brown' ? 'marron' : n === 'noir' || n === 'black' ? 'noir' : n;
    });
    /* Galerie : le détouré fond blanc EN PREMIER, pour tout le monde. C'est ce
       qui met sacs et anses à la même enseigne : une grille où chaque pièce est
       montrée de la même façon, comme un catalogue. Les photos portées suivent,
       elles nourrissent la fiche et la bande « Porté » de la page maroquinerie.
       Les recadrages basse définition sont retirés dès qu'on a mieux.
       Depuis le 28 sept, ces photos sont rattachées aux fiches Shopify dans cet
       ordre : une fiche Shopify garde ses photos telles quelles, et Charlotte
       les ordonne ou les remplace dans l'admin. */
    if (deShopify) {
      o.images = (o.images || []).slice();
      o.img = o.images[0];
      return o;
    }
    var plus = PHOTOS_EN_PLUS[o.id] || [];
    var packs = PACKSHOTS[o.id] || [];
    var reste = (o.images || []).filter(function (u) {
      return !(packs.length && BASSE_DEF.test(String(u)));
    });
    o.images = packs.concat(plus, reste);
    o.img = o.images[0];
    return o;
  }

  /* ---------- Source 1 : Shopify en direct (thème) ---------- */
  var shopSacs = (typeof window !== 'undefined' && window.SHOP && window.SHOP.sacs) || null;
  /* Liquid ne voit pas un brouillon. La copie des fiches, brouillons compris, est
     relue dans l'admin par scripts/maroquinerie_brouillons.py et rangée dans le
     méta-champ de boutique yolete.sacs_brouillons (28 sept 2026). */
  var copie = (typeof window !== 'undefined' && window.SHOP && window.SHOP.sacsBrouillons) || null;
  if (copie && !copie.length) copie = null;
  var items;

  /* ---------- Source 2 : repli statique (site Vercel) ---------- */
  function depuisRepli(o) {
    return decorate({
      id: o.id,
      name: o.name,
      nomComplet: o.name,
      price: o.price,
      images: o.images.map(function (f) { return CDN + f; }),
      colors: o.colors.map(function (c) {
        return { name: c, img: CDN + o.images[0], dot: TEINTE[c] || null };
      }),
      descr: o.descr,
      variants: [],
      variantId: null,
      available: false,     /* brouillons Shopify : rien n'est achetable pour l'instant */
      bientot: true         /* « Bientôt », pas « Épuisé » : la collection n'est pas sortie */
    });
  }

  function depuisShop(p, bientot) {
    var colors = [], seen = {};
    (p.variants || []).forEach(function (v) {
      var n = v.option1 || '';
      if (!n || n === 'Default Title' || seen[n]) return;
      seen[n] = 1;
      colors.push({ name: n, img: v.image || (p.images || [])[0] || '', dot: TEINTE[n] || null });
    });
    var firstAvail = (p.variants || []).find(function (v) { return v.available; }) || (p.variants || [])[0];
    return decorate({
      id: p.handle,
      name: nomCourt(p.title),
      nomComplet: p.title,
      price: p.price,
      images: (p.images || []).slice(),
      colors: colors,
      descr: String(p.descr || '').trim(),
      descrHtml: p.descrHtml || '',
      details: p.details || '',
      tags: p.tags || [],
      variants: p.variants || [],
      variantId: firstAvail ? firstAvail.id : null,
      available: !!p.available,
      maro: p.maro || null,
      precommande: p.precommande || '',
      /* Sans prix, une fiche n'est pas « épuisée » : elle n'est pas encore
         ouverte à la vente. La nuance change le mot affiché sur la carte. */
      bientot: bientot
    }, true);
  }

  if ((shopSacs && shopSacs.length) || copie) {
    /* Dévoilement sans vente (25 sept 2026) : des fiches actives mais non
       achetables. Tant qu'aucune pièce n'est en vente, la collection n'est pas
       ouverte, donc chaque pièce reste « Bientôt » avec « Être prévenue à
       l'ouverture », jamais « Épuisé ». Une pièce encore en brouillon garde sa
       place grâce à la copie des brouillons. Dès qu'une pièce est en vente,
       Shopify en direct fait seul foi. */
    var enLigne = shopSacs || [];
    var enVente = enLigne.some(function (p) { return p.available && p.price > 0; });
    items = enLigne.map(function (p) { return depuisShop(p, !(p.price > 0) || !enVente); });
    if (!enVente) {
      var vus = {};
      items.forEach(function (o) { vus[o.id] = 1; });
      (copie || []).forEach(function (p) {
        if (!vus[p.handle]) { vus[p.handle] = 1; items.push(depuisShop(p, true)); }
      });
      /* Le relevé du book ne comble plus rien dès que la copie existe : une
         pièce retirée de Shopify ne doit pas revenir par le code. */
      if (!copie && !window.SHOP) FALLBACK.forEach(function (o) { if (!vus[o.id]) items.push(depuisRepli(o)); });
    }
    /* Ordre de la collection « maroquinerie » dans Shopify (tri manuel depuis le
       28 sept) : Charlotte range les pièces en les faisant glisser dans l'admin. */
    var rang = {};
    (copie || enLigne).forEach(function (p, i) { rang[p.handle] = i; });
    items.sort(function (a, b) {
      return (a.id in rang ? rang[a.id] : 999) - (b.id in rang ? rang[b.id] : 999);
    });
  } else if (window.SHOP) {
    /* Boutique sans pièce lisible : rien plutôt que des prix écrits dans le code (21/10/2026). */
    items = [];
  } else {
    items = FALLBACK.map(depuisRepli);
    /* Ordre éditorial, puis tout ce qui n'est pas prévu à la suite. */
    items.sort(function (a, b) {
      var ia = ORDER.indexOf(a.id), ib = ORDER.indexOf(b.id);
      return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
    });
  }

  /* Remplace toute maroquinerie déjà présente, puis publie la liste. */
  for (var i = PRODUCTS.length - 1; i >= 0; i--) {
    if (PRODUCTS[i].type === 'sac' || PRODUCTS[i].type === 'anse') PRODUCTS.splice(i, 1);
  }
  PRODUCTS.push.apply(PRODUCTS, items);

  if (typeof TYPE_LABEL !== 'undefined') { TYPE_LABEL.sac = 'Sac'; TYPE_LABEL.anse = 'Anse'; }
  window.MAROQUINERIE = items;
})();
